'use strict';
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/shortid/index.js
// module id = 977
// module chunks = 1